"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendFBPixel = exports.FacebookPixelLocation = void 0;
const react_1 = require("react");
const react_facebook_pixel_1 = __importDefault(require("react-facebook-pixel"));
const react_router_dom_1 = require("react-router-dom");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const FacebookPixelLocation = ({ children }) => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const pagePixel = {};
    pagePixel[RoutesPaths_1.routesPaths.bookSuite] = 'BookSuiteTrack';
    pagePixel[RoutesPaths_1.routesPaths.landingPage] = 'LandingPageTrack';
    pagePixel[RoutesPaths_1.routesPaths.root] = 'HomeTrack';
    (0, react_1.useEffect)(() => {
        if (pagePixel[pathname]) {
            react_facebook_pixel_1.default.track(pagePixel[pathname], 'ViewContent');
        }
    }, [pathname, pagePixel]);
    return children;
};
exports.FacebookPixelLocation = FacebookPixelLocation;
function sendFBPixel(event, data) {
    react_facebook_pixel_1.default.track(event, data);
}
exports.sendFBPixel = sendFBPixel;
